export default __webpack_public_path__ + "static/media/colors-editable.dd04bafc.png";